import React, { Component } from 'react'
import { InputFieldStyle } from './style'
import { IMG } from '../../themes'

export class InputField extends Component {
  render () {
    const {
      placeholder,
      value,
      onChange,
      className = '',
      type,
      disabled,
      maxLength,
      onBlur,
      autocomplete,
      icon,
      typeIcon,
      onFocus
    } = this.props
    return (
      <InputFieldStyle cursor= {disabled ? 'not-allowed' : 'pointer'}>
        <div
          className={`div-search-select ${className}${ disabled ? ' disabled' : ''}`}
          onFocus={ onFocus }
          style={{pointerEvents: disabled ? 'none' : 'auto'}}
        >
          <input
            maxLength={maxLength}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className={ typeIcon === 'autosuggest' ? 
              'input-search-dropdown' 
              : `input-field ${className} ${disabled ? 'disabled' : ''}`
            }
            type={type || 'text'}
            disabled={disabled}
            accept='image/jpeg, image/png, image/jpg'
            onBlur={onBlur}
            autoComplete={autocomplete}
          />
          {
            typeIcon === 'autosuggest' &&
            <img
              className='icon-search-dropdown'
              src={ IMG[icon]}
              alt={ icon }
            />
          }
        </div>
      </InputFieldStyle>
    )
  }
}
